var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collection-form',{attrs:{"value":_vm.collection,"title":_vm.pageTitle},on:{"submit":_vm.save}},[_c('template',{slot:"actions"},[_c('form-button',{attrs:{"kind":"submit","type":"submit"}},[_vm._v("Enregistrer")]),_vm._v(" "),_c('form-button',{attrs:{"kind":"cancel"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Annuler")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3963a980","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/collections/CollectionCreate.vue
// module id = 892
// module chunks = 7